export enum CameraStatus {
  Online = 'Online',
  Active = 'active',
  Recording = 'recording',
  NotRecording = 'notRecording',
  Streaming = 'streaming',
  NotStreaming = 'notStreaming',
  Offline = 'Offline',
  Error = 'error',
  Pending = 'Pending'
}
